import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=0cf7588c&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=0cf7588c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7588c",
  null
  
)

export default component.exports